import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user, ready } = useAuth();
  const loc = useLocation();
  if (!ready) return <div className="p-8 text-sm font-mono">Yükleniyor…</div>;
  if (!user) return <Navigate to="/giris" state={{ from: loc }} replace />;
  if (roles && !roles.includes(user.role) && user.role !== "admin" && user.role !== "sub_admin") {
    return <Navigate to="/" replace />;
  }
  return children;
}
